import axios from '@axios'

export default {
  async getUserCampaigns(context) {
    try {
      const response = await axios.get('campaign/all')
      // console.log(response.data)
      if (response.status === 200) {
        if (response.data.success) {
          context.commit('setUserCampaings', response.data.data)
        }
      }
    } catch (error) {
      console.log(error)
    }
  },
}
